import { GetLocalStorage } from "../../../utils/localStorgeOperations";
export function approvePayLoadItems(doc, constants) {
  return {
    ...doc,
    projectStatus: "complete",
    approver_id: GetLocalStorage(constants.userId),
    approver: GetLocalStorage(constants.username),
  };
}
